import React from "react";

const FooterListTitle = ({ title }) => {
  return <h3 className="text-xl font-poppins font-medium  mb-6">{title}</h3>;
};

export default FooterListTitle;
